import QuestionManager from "./QuestionManager";
export default QuestionManager;
